import React from 'react';
import {
  validateEmail,
  validateIdNumber,
  validateRequired,
} from "../../../services/validationFunctions";

import errorIcon from "../../../assets/icons/error.svg";
import billingIcon from "../../../assets/icons/billing.svg";

const BillingForm = ({ data, onChange, onBlur }) => {
  const handleIdNumberBlur = () => {
    const validationResult = validateIdNumber(data.idNumber, data.idType);
    onBlur("idNumber", () => validationResult);
  };

  return (

    <div className="billing-dropdown__container">
      <div className="billing-dropdown__button">
        <div className="billing-dropdown__button-elements">
          <div className="billing-icon">
          <img src={billingIcon} alt="billing" />
          </div>
          <span>
            {data.fullName ? data.fullName : `Ingresar datos de facturación `}
          </span>
        </div>
      </div>
      <form className="billing-dropdown__form">
        <div
          className={`billing-dropdown__form-row${
            data.errors.fullName ? " error" : ""
          }`}
        >
          <label htmlFor={`fullName`}>Nombre completo</label>
          <input
            id={`fullName`}
            type="text"
            placeholder="Ingresa tu nombre completo"
            value={data.fullName}
            onChange={(e) => onChange("fullName", e.target.value)}
            onBlur={() => onBlur("fullName", validateRequired)}
          />
          {data.errors.fullName && (
            <div className="error">
              <img src={errorIcon} alt="Error" />
              {data.errors.fullName}
            </div>
          )}
        </div>
        <div
          className={`billing-dropdown__form-row${
            data.errors.email ? " error" : ""
          }`}
        >
          <label htmlFor={`email`}>Correo electrónico</label>
          <input
            id={`email`}
            type="email"
            placeholder="email@ejemplo.com"
            value={data.email}
            onChange={(e) => onChange("email", e.target.value)}
            onBlur={() => onBlur("email", validateEmail)}
          />
          {data.errors.email && (
            <div className="error">
              <img src={errorIcon} alt="Error" />
              {data.errors.email}
            </div>
          )}
        </div>
        <div
          className={`billing-dropdown__form-row${
            data.errors.address ? " error" : ""
          }`}
        >
          <label htmlFor={`address`}>Dirección</label>
          <input
            id={`address`}
            type="text"
            placeholder="Ingresa calle y altura"
            value={data.address}
            onChange={(e) => onChange("address", e.target.value)}
            onBlur={() => onBlur("address", validateRequired)}
          />
          {data.errors.address && (
            <div className="error">
              <img src={errorIcon} alt="Error" />
              {data.errors.address}
            </div>
          )}
        </div>
        <div className="billing-dropdown__form-row billing-dropdown__form-grid">
          <div className={`${data.errors.zipCode ? " error" : ""}`}>
            <label htmlFor={`dob`}>Código postal</label>
            <input
              id={`zipCode`}
              type="text"
              placeholder="Ingresa el código postal"
              value={data.zipCode}
              onChange={(e) => onChange("zipCode", e.target.value)}
              onBlur={() => onBlur("zipCode", validateRequired)}
            />
            {data.errors.zipCode && (
              <div className="error">
                <img src={errorIcon} alt="Error" />
                {data.errors.zipCode}
              </div>
            )}
          </div>
          <div className={`${data.errors.country ? " error" : ""}`}>
            <label htmlFor={`country`}>País</label>
            <input
              id={`country`}
              type="text"
              placeholder="País de residencia"
              value={data.country}
              onChange={(e) => onChange("country", e.target.value)}
              onBlur={() => onBlur("country", validateRequired)}
            />
            {data.errors.country && (
              <div className="error">
                <img src={errorIcon} alt="Error" />
                {data.errors.country}
              </div>
            )}
          </div>
        </div>
        <div className="billing-dropdown__form-row billing-dropdown__form-grid">
          <div className={`${data.errors.idType ? " error" : ""}`}>
            <label htmlFor={`idType`}>Tipo de documento</label>
            <select
              id={`idType`}
              value={data.idType}
              onChange={(e) => onChange("idType", e.target.value)}
              onBlur={() => onBlur("idType", validateRequired)}
            >
              <option value="" disabled>Tipo de documento</option>
              <option value="passport">Passport</option>
              <option value="nationalId">DNI / CUIT</option>
            </select>
            {data.errors.idType && (
              <div className="error">
                <img src={errorIcon} alt="Error" />
                {data.errors.idType}
              </div>
            )}
          </div>
          <div className={`${data.errors.idNumber ? " error" : ""}`}>
            <label htmlFor={`idNumber`}>Número de documento</label>
            <input
              id={`idNumber`}
              type="text"
              placeholder="Ingresar número de documento"
              value={data.idNumber}
              onChange={(e) => onChange("idNumber", e.target.value)}
              onBlur={handleIdNumberBlur}
            />
            {data.errors.idNumber && (
              <div className="error">
                <img src={errorIcon} alt="Error" />
                {data.errors.idNumber}
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default BillingForm;
